export const SITE_CONFIG = {
    google_captcha_site_key: "6LfoHdQUAAAAALAZcE7V8zKyZb2lZGrWRcIKT2yg"
};